import { render, staticRenderFns } from "./ExhibitCardSpecial.vue?vue&type=template&id=bdc4979a"
import script from "./ExhibitCardSpecial.vue?vue&type=script&lang=js"
export * from "./ExhibitCardSpecial.vue?vue&type=script&lang=js"
import style0 from "./ExhibitCardSpecial.vue?vue&type=style&index=0&id=bdc4979a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports